type ChildrenContainerProps = { children: React.ReactNode };

const ChildrenContainer = ({ children }: ChildrenContainerProps) => {
	return (
		<div className={`vtex-minicart-2-x-childrenContainer flex flex-grow-1`} style={{ height: '100%' }}>
			{children}
		</div>
	);
};

export default ChildrenContainer;
